export const translations = {
  'de-DE': {
    translation: {
      addUser: 'Benutzer hinzufügen',
      editUser: 'Benutzer bearbeiten',
      firstName: 'Vorname',
      lastName: 'Nachname',
      name: 'Name',
      role: 'Rolle',
      status: 'Status',
      email: 'E-Mail',
      phone: 'Telefon',
      type: 'Typ',
      details: 'Details',
      nodes: 'Knoten',
      roles: 'Rollen',
      cancel: 'Abbrechen',
      submit: 'Senden',
      delete: 'Löschen',
      create: 'Erstellen',
      deleteNodeError: 'Fehler beim Löschen des Knotens',
      deleteConfirmation: 'Möchten Sie wirklich löschen?',
      warning: 'Warnung',
      Alert: 'Warnung',
      deleteSure: 'Ja, ich bin mir sicher',
      nodesWillBeCreatedAt: 'Knoten werden erstellt:',
      searchFor: 'Suchen nach',
      rolesError: 'Fehler beim Abrufen der Rollen',
      userListError: 'Fehler beim Abruf der Benutzerliste',
      organisationListError: 'Fehler beim Abrufen der Organisationsliste',
      loadingRoles: 'Rollen werden geladen ...',
      selectRole: 'Rolle auswählen',
      validEmail: 'Geben Sie eine gültige E-Mail-Adresse ein.',
      requiredEmail: 'E-Mail-Adresse ist erforderlich',
      resend: 'Erneut senden',
      restrictedDomain: 'Restricted email domain',
      addUserSuccess: 'Benutzer erfolgreich hinzugefügt',
      editUserSuccess: 'Benutzer erfolgreich bearbeitet',
      deleteUserSuccess: 'Benutzer erfolgreich gelöscht',
      deleteModalAlertMessage:
        'Sie sind dabei, den Benutzer {{userName}} zu löschen. Alle Berechtigungen für den Benutzer werden widerrufen.',
      deleteProceedMessage: 'Möchten Sie mit dem Löschen fortfahren?',
      userAlreadyExist: 'Benutzer mit dieser E-Mail-ID ist bereits vorhanden.',
      addUserError:
        'Benutzer konnte nicht hinzugefügt werden. Versuchen Sie es erneut.',
      editUserError:
        'Benutzer konnte nicht bearbeitet werden. Versuchen Sie es erneut.',
      deleteUserError:
        'Benutzer konnte nicht gelöscht werden. Bitte versuche es erneut.',
      nodesError: 'Fehler beim Abruf der zugewiesenen Knoten',
      childNodesError: 'Fehler beim Laden der untergeordneten Knoten',
      hierarchyError: 'Fehler beim Abruf der Hierarchie',
      requestFailed: 'Anfrage fehlgeschlagen',
      emailSentSuccess: 'Die Aktivierungs-E-Mail wurde erfolgreich gesendet!',
      activationEmailError: 'Aktivierungs-E-Mail konnte nicht gesendet werden.',
      activationEmailError1:
        'Die Aktivierungs-E-Mail konnte nicht gesendet werden. Versuchen Sie es später erneut.',
      allOrganisations: 'Alle Organisationen',
      address: 'Adresse',
      hierarchyMetaError: 'Fehler beim Abruf der Hierarchiedetails',
      nodeMetaError: 'Fehler beim Laden der Knotendetails',
      contactName: 'Name des Ansprechpartners',
      downloadTemplate: 'Vorlage herunterladen',
      newOrg: 'Neue Organisation',
      save: 'Speichern',
      upload: 'Hochladen',
      uploading: 'Hochladen',
      dropExcel: 'Excel-Tabelle ablegen oder',
      browse: 'Durchsuchen',
      importSettings: 'Einstellungen importieren',
      addNodesSites: 'Neue Knoten/Standorte hinzufügen',
      updateNodesSites:
        'Informationen zu bestehenden Knoten/Standorten aktualisieren',
      disableNodesSites:
        'Deaktivieren von Knoten/Standorten, die nicht mehr vorhanden sind',
      disabled: 'Gesperrt',
      new: 'Neu',
      updated: 'Aktualisiert',
      siteInstallation: 'Standorte',
      addOrgSuccess: 'Organisation erfolgreich erstellt!',
      excelUploadError:
        'Speichern der Excel-Tabelle fehlgeschlagen. Versuchen Sie es erneut.',
      saveError: 'Speichern fehlgeschlagen. Versuchen Sie es später erneut.',
      saveBadRequestError:
        'Fehler beim Speichern. Dies ist wahrscheinlich ein Problem mit den Daten, die Sie speichern wollten.',
      telephone: 'Telefon',
      externalIds: 'externe IDs',
      contactEmail: 'Kontakt E-mail',
      longitude: 'Längengrad',
      latitude: 'Breitengrad',
      primaryContactName: 'Name des primären Ansprechpartners',
      primaryContactEmail: 'Primäre Kontakt-E-Mail',
      templateError:
        'Fehler beim Herunterladen der Vorlage. Versuchen Sie es später erneut.',
      templateError1:
        'Vorlage konnte nicht abgerufen werden. Versuchen Sie es später erneut.',
      home: 'Startseite',
      organisations: 'Organisationen',
      users: 'Benutzer',
      lightTheme: 'Helles Thema',
      darkTheme: 'Dunkles Thema',
      login: 'Anmelden',
      logout: 'Abmelden',
      activateUserAcc: 'Benutzerkonto aktivieren',
      phoneNumber: 'Telefonnummer',
      optional: 'Optional',
      password: 'Passwort',
      confirmPassword: 'Passwort bestätigen',
      endUser: 'Endbenutzer-Lizenzvertrag',
      iAccept: 'Ich akzeptiere die Endbenutzerlizenzvereinbarung.',
      iHereby: 'Ich bestätige hiermit, dass ich die',
      eula: 'EULA',
      iRead: 'Ich habe die Honeywell-Datenschutzerklärung gelesen',
      iUnderstood: 'Ja, ich habe die',
      privacyPolicy: 'Datenschutzrichtlinie',
      activate: 'Aktivieren',
      activationSuccess: 'Aktivierung erfolgreich',
      newAccAccess:
        'Um auf Ihr neues Konto zugreifen zu können, melden Sie sich mit Ihrem neuen Benutzernamen an. Dieser neue Benutzername wird nachfolgend angezeigt:',
      emailSent: 'Der neue Benutzername wurde an Ihre E-Mail-ID gesendet.',
      signin: 'ANMELDEN',
      activationError: 'Aktivierung fehlgeschlagen',
      pleaseTryAgain: 'Versuchen Sie es erneut.',
      activationExpired: 'Aktivierungstoken abgelaufen',
      activationExpiredText:
        'Der Grund dafür könnte sein, dass die Zeit für den E-Mail-Link abgelaufen ist, der Link bereits verwendet wurde oder nicht korrekt war. Wenn das Problem weiter besteht, fordern Sie eine neue Aktivierungs-E-Mail an.',
      contactSupport: 'Fehler. Wenden Sie sich an den Support',
      pwdMatch: 'Die Passwörter müssen übereinstimmen',
      required: 'Erforderlich',
      eligiblePwd:
        'Das Passwort muss mindestens ein Großbuchstaben, einen Kleinbuchstaben, eine Ziffer, ein Sonderzeichen und mindestens 11 Zeichen enthalten',
      invalidPhoneNumber: 'Telefonnummer ungültig',
      invalidName:
        'Der Name darf höchstens 255 Zeichen ohne Leerstellen vorn und hinten enthalten.',
      invalidFirstName: 'FirstName contains invalid characters.',
      invalidLastName: 'LastName contains invalid characters.',
      timezone: 'Zeitzone',
      timeZone: 'Zeitzone',
      commissioningStatus: 'Inbetriebnahmestatus',
      countryCode: 'Ländervorwahl',
      childCount: 'Anzahl untergeordneter Elemente',
      sheetVersion: 'Blattversion',
      unknownError: 'Unbekannter Fehler. Versuchen Sie es später erneut.',
      preview: 'Vorschau',
      file: 'Datei',
      inCompatibleExcel: 'Die Datei muss im Format .xlsx sein.',
      selectOrg: 'Organisation auswählen',
      noRecordFound: 'Keine Datensätze gefunden',
      total: 'Gesamt',
      items: 'Objekte',
      forbidden: 'Unzulässig',
      noPermissionText:
        'Sie sind nicht berechtigt, auf diese Seite zu zugreifen',
      accessPermission:
        'Melden Sie sich bei einem Konto mit Zugriffsberechtigungen an.',
      technicianExternalAccessPermission:
        'Bitte melden Sie sich bei der mobilen App an.',
      redirectToLogin: 'Weiterleitung zur Anmeldeseite',
      errorUserSettings: 'Fehler beim Abruf der Benutzereinstellungen',
      invalidSystemGuid: 'Ungültige System-GUID',
      languageNotSupported: 'Sprache nicht unterstützt',
      subscriptions: 'Abonnements',
      gatewayManagement: 'Gateway-Verwaltung',
      subscriptionNumber: 'Abonnementnummer',
      orderNumber: 'Bestellnummer',
      bundle: 'Bundle',
      activatedOn: 'Aktivierungsdatum',
      order: 'Auftrag',
      editSubscription: 'Abonnement bearbeiten',
      noNodeSelected: 'Kein Knoten ausgewählt',
      noUserSelected: 'Kein Benutzer ausgewählt',
      loadingBundles: 'Bundles werden geladen ...',
      bundlesError: 'Fehler beim Abrufen von Bundles ...',
      selectBundle: 'Bundle auswählen',
      addSubscriptionSuccess: 'Abonnement erfolgreich hinzugefügt',
      addSubscriptionError:
        'Abonnement konnte nicht hinzugefügt werden. Versuchen Sie es erneut.',
      subscriptionInputValidationError:
        'Kann ein alphanumerischer Wert mit einem Bindestrich sein und darf 13 Zeichen nicht überschreiten',
      errorUserGlobalPrivileges:
        'Fehler beim Abrufen globaler Benutzerberechtigungen',
      subscriptionAlreadyExist: 'Abonnement ist bereits vorhanden.',
      invalidSubscription: 'Ungültiges Abonnement',
      Version: 'Version',
      systemType: 'Systemtyp',
      systemId: 'System-ID',
      reviewGatewayDetails: 'Gateway-Details überprüfen',
      site: 'Standort',
      Organisation: 'Organisation',
      gatewayRegistration: 'Gateway-Registrierung',
      selectAnOrg: 'Wählen Sie eine Organisation aus',
      selectASite: 'Einen Standort auswählen',
      register: 'Registrieren',
      selectSiteToRegsiter:
        'Wählen Sie die Site aus, um das Gateway zu registrieren',
      gatewayRegistrationFailureMsg:
        'Fehler beim Registrieren des Gateways bei der Honeywell Sentience IOT-Plattform',
      gatewayRegistrationSuccessMsg:
        'Gateway wurde erfolgreich bei der Honeywell Sentience IOT Platform registriert',
      siteEmptyMsg:
        'Alle Websites der Organisation {{- orgName}} sind bereits registriert',
      forgeOnboarding: 'Organisationszuordnung',
      SiteFetchingFailure: 'Fehler beim Abrufen von Standorten aus Forge',
      selectAllSitesText:
        'Alle Forge-Standorte für Onboarding bei Remote Building Manager auswählen',
      onBoardingFailure: 'Fehler beim Initiieren des Standort-Onboardings',
      customerID: 'Kunden-ID',
      enterCustomerID: 'Kunden-ID eingeben',
      loadingSites: 'Standorte werden geladen...',
      fetchSites: 'STANDORTE ABRUFEN',
      subscriptionActivateSuccess:
        'Abonnement für "{{siteName}}" wurde erfolgreich aktiviert',
      subscriptionActivateError:
        'Kann aufgrund eines technischen Problems nicht aktiviert werden. Bitte wenden Sie sich an Ihren Administrator',
      activateNow: 'Jetzt aktivieren',
      multiSiteSuccess: 'Standorte wurden erfolgreich hinzugefügt.',
      onboardSelected: 'Einbinden ausgewählt',
      sitePartialSuccess:
        'Einige Standorte konnten aufgrund eines technischen Problems nicht eingebunden werden. Versuchen Sie es erneut, oder wenden Sie sich an Ihren Administrator.',
      confirm: 'Bestätigen',
      onboardingFailed: 'Onboarding fehlgeschlagen',
      failed: 'Fehlgeschlagen',
      onboardedSuccessfully: 'Standort-Onboarding abgeschlossen',
      notOnboarded: 'Nicht eingebunden',
      onboarding: 'Einbindung wird ausgeführt...',
      reOnboard: 'Erneut einbinden',
      selectAll: 'Alle auswählen',
      siteSuccess: 'Standort wurde erfolgreich hinzugefügt.',
      dataloseWarning:
        'Aktualisieren Sie die Seite nicht, während Standorte eingebunden werden.',
      addServiceSuccess: 'Dienste erfolgreich hinzugefügt',
      addServicesText: 'Dienste hinzufügen',
      validityText: 'Gültigkeitszeitraum',
      invalidInputError: 'Ungültige Eingabe',
      subsactivateError: 'Abonnement bereits aktiviert',
      subsnotfoundError: 'Abonnementdetails nicht gefunden',
      invalidorderError: 'Ungültige Bestellnummer',
      bundnotfoundError: 'Bundle-Details nicht gefunden',
      subscribedServices: 'ABONNIERTE DIENSTE',
      subsactivateSuccess: 'Abonnement erfolgreich erstellt und aktiviert',
      subsactivateFailure:
        'Abonnement erstellt, aber Aktivierung fehlgeschlagen. Bitte versuche es erneut !!',
      subsactivateDiffSite: 'Abonnement bereits für eine andere Site aktiviert',
      gatewayAssociation: 'Gateway-Zuordnung',
      systemGuid: 'System-GUID',
      success: 'Erfolg',
      contactSystemAdministrator:
        'Wenden Sie sich an Ihren Systemadministrator.',
      siteName: 'Standortliste',
      location: 'Ort',
      action: 'Aktion',
      addNewSite: 'Neue Website hinzufügen',
      add: 'Hinzufügen',
      sitesAssociated: '{{siteCount}} Verbundene Websites',
      numberOfAddon: 'Number of Addon',
      searchSite: 'Standorte durchsuchen',
      noResultFound: 'Keine Ergebnisse gefunden',
      noDataFound: 'Keine Daten gefunden',
      loadMore: 'Weitere laden',
      unlinkMessage:
        'Um {{siteName}} von der {{sku}} zu entbinden, wenden Sie sich bitte an das Honeywell Customer Care Center (+01 480-353-3020) oder senden Sie eine E-Mail an support@honeywell.com',
      associatedOrderNumber: 'Zugehörige Bestellnummer',
      associatedSubscriptionNumber: 'Zugehörige Abonnementnummer',
      helperTextSKU:
        'Um die Abonnementnummer zu ändern, wenden Sie sich bitte an',
      helperOrderTextSKU:
        'Um die Bestellnummer zu ändern, wenden Sie sich bitte an',
      customerCare: 'Kundendienst',
      skuDetails: 'SKU-Details',
      manageSites: 'Websites verwalten',
      skuName: 'SKU-Name',
      skuDescription: 'SKU-Beschreibung',
      licenseUtilization: 'Lizenznutzung',
      validTill: 'Gültig bis',
      editSKU: 'Artikelnummer bearbeiten',
      duplicateSiteError: 'Website wurde bereits hinzugefügt',
      numberOfAddonRequired: 'Please enter Number of Addon',
      siteFetchError: 'Fehler beim Abrufen der Site-Liste',
      siteSuccessMsg: 'Seiten erfolgreich hinzugefügt',
      siteFailedMsg: 'Websites konnten nicht hinzugefügt werden',
      problemWithRequest: 'There was a problem with the request.',
      newSubscriptionAdded: 'Neues Abonnement hinzugefügt',
      licensesOf: 'Lizenzen von',
      all: 'Alle',
      orderPlacedBy: 'Bestellung aufgegeben von',
      pendingRenewal: 'Ausstehende Erneuerung',
      daysRemaining: 'verbleibende Tage',
      renewSubscriptionMessage:
        'Erneuern {{skuName}}, wenden Sie sich bitte an das Honeywell Customer Care Center (+01 480-353-3020) oder senden Sie eine E-Mail an support@honeywell.com',
      columnSelection: 'SPALTENAUSWAHL',
      selectUpTo: 'Wählen Sie bis zu',
      itemsToDisplay: 'Objekte, die in der Tabelle angezeigt werden.',
      subscriptionManagement: 'Abonnementverwaltung',
      activated: 'Aktiviert',
      warningHeader: 'Möchten Sie wirklich abbrechen?',
      warningMessage: 'Ungespeicherte Änderungen gehen verloren',
      renewSubscription: 'Abonnement erneuern',
      pendingActivation: 'Ausstehende Aktivierung',
      notAuthorizedError:
        'Sie sind nicht berechtigt, diese Organisation SKU zuzuweisen',
      gatewayRegistrationInProgress: '{{gateway}} in Bearbeitung',
      gatewayAssociationFailed:
        'Überprüfen Sie die Gateway-Verbindung und versuchen Sie es erneut. Wenn der Fehler weiterhin auftritt, wenden Sie sich an Ihren Systemadministrator.',
      gatewayRegistrationFailed:
        'Bitte versuchen Sie es erneut. Wenn der Fehler weiterhin auftritt, wenden Sie sich an Ihren Systemadministrator.',
      doAssociationMessage:
        'Please check gateway connectivity and proceed with gateway association.',
      errorInAssociation: 'Fehler bei der Verarbeitung der Zuordnung.',
      association: 'Zuordnung',
      dataloseWarningForRegistration:
        'Die Gateway-Registrierung wird durchgeführt. Dies kann einige Minuten in Anspruch nehmen. Bitte nicht aktualisieren, um Datenverlust zu vermeiden.',
      dataloseWarningForAssociation:
        'Die Gateway-Zuordnung wird durchgeführt. Dies kann einige Minuten in Anspruch nehmen. Bitte nicht aktualisieren, um Datenverlust zu vermeiden.',
      objectName: 'Object Name',
      objectType: 'Object Type',
      unitName: 'Einheit',
      bitunpack: 'Bit Unpack',
      bitRange: 'Bit Range',
      propName: 'Prop Name',
      propDataType: 'Data Type',
      propValue: 'Prop Value',
      msgType: 'MESSAGE TYPE',
      isMultiState: 'Is Multi State',
      scalingOperation: 'Scaling Operation',
      scalingFactor: 'Scaling Factor',
      byteOrder: 'Byte Order',
      propertyName: 'Property Name',
      addTemplateSuccess: 'Vorlage erfolgreich hinzugefügt',
      addTemplateError:
        'Konnte keine Vorlage hinzufügen.Bitte versuche es erneut.',
      updateTemplateSuccess: 'Vorlage erfolgreich aktualisiert',
      updateTemplateError:
        'Konnte die Vorlage nicht aktualisieren.Bitte versuche es erneut.',
      outOfRangeError: 'Der Wert muss zwischen {{min}} und {{max}} liegen',
      requiredField: 'Bitte füllen Sie alle Felder aus',
      templateName: 'Vorlagenname',
      modelName: 'Modellname',
      vendorName: 'Herstellername',
      uniqueValueError: 'Wert muss eindeutig sein',
      templateMangement: 'Vorlagenverwaltung',
      equipmentType: 'Ausstattungsart',
      selectType: 'Typ auswählen',
      listOfTemplate: 'Liste der Vorlage',
      selectTemplate: 'Vorlage auswählen',
      ElectricityVoltage: 'Stromspannung',
      ElectricityCurrent: 'Stromstrom',
      ElectricPowerFactor: 'Elektrischer Leistungsfaktor',
      ElectricFrequency: 'Elektrische Frequenz',
      EnergyReceived: 'Energie erhalten',
      ActivePower: 'Aktive Kraft',
      ActivePowerA: 'Aktive Kraft A',
      ActivePowerB: 'Aktive Leistung B',
      ActivePowerC: 'Aktive Leistung C',
      ReactivePower: 'Blindleistung',
      ApparentPower: 'Scheinbare Kraft',
      PeakDemand: 'Spitzenbedarf',
      ElectricityCurrentA: 'Stromstrom a',
      ElectricityCurrentB: 'Stromstrom B',
      ElectricityCurrentC: 'Stromstrom C',
      ElectricityVoltageA: 'Stromspannung A',
      ElectricityVoltageB: 'Stromspannung B',
      ElectricityVoltageC: 'Stromspannung C',
      ElectricityConsumption: 'Stromverbrauch',
      loaderWelcomeMessage: 'Willkommen beim Onboarding-Portal. Bitte warten.',
      latitudeAndLongitude: 'Breite & Längengrad',
      siteUpdateSuccessMessage: 'Website-Details erfolgreich aktualisiert',
      siteUpdateErrorMessage: 'Fehler beim Aktualisieren der Website-Details',
      provisioningFailedMessages:
        'Die Standortbereitstellung ist fehlgeschlagen. Bitte versuchen Sie es erneut',
      onboardAllSites: 'Onboarding für alle Standorte abgeschlossen',
      geoCordinatesErrorMsg: 'Bitte überprüfen Sie die Koordinaten',
      tooltipCordinateMessage: 'Koordinaten müssen liegen zwischen',
      emptyValueMessage: 'Leerer Wert nicht erlaubt',

      browseFile: 'Browse File',
      fileTypeErrorMsg: 'File type is not allowed',

      orgImgTitle: 'Upload Organization Logo',
      orgImgDropTxt: 'Drag and Drop Logo',
      orgImgInfoTxt:
        'W {{width}}px X H {{height}}px and Only *.png file format',
      orgImgPreviewTxt: 'Preview Logo',
      orgImgTooltipTxt:
        'Logo to have transparent background and should contrast black header background',
      orgImgSizeOfErrorMsg:
        'Image size should be max width {{width}}px, max height {{height}}px, minimum width {{minWidth}}px, minimum height {{minHeight}}px and max size {{maxSize}}kb',

      siteImgTitle: 'Upload Site image',
      siteImgDropTxt: 'Drag and Drop Building image (*.png or .jpg)',
      siteImgPreviewTxt: 'Preview Site Details Page',
      siteTooltipTxt:
        'Image will be cropped 46px on right & left and 30px on top & bottom part of the image based on different monitor resolution',
      siteImgInfoTxt:
        'W {{width}}px X H {{height}}px and *.png & *.jpg file format',
      siteImgSizeOfErrorMsg:
        'Image size should be max width {{width}}px, height {{height}}px and size {{maxSize}}kb',
      orTxt: 'Or',
      addLogo: 'Add Logo',
      addImage: 'Add Image',
      imageUploadSuccess: 'Image Uploaded Successfully',
      alertnteId: 'Alternativer Benutzername:',
      username: 'Nutzername:',
      errorFetchingUser: 'Fehler beim Abrufen des Benutzers',
      errorFetchingRoles: 'Fehler beim Abrufen der Rollen',

      gateway: 'GATEWAY',
      associateAndSyncBtn: 'ASSOZIIEREN & SYNCHRONISIEREN',
      cancelBtn: 'ABBRECHEN',
      guidValidationError: 'GUID-Validierungsfehler',
      gatewayId: 'GATEWAY-ID',
      addNewGateway: 'Neue Gateway hinzufügen',
      successMessage1: 'Verknüpfung der Seite, abgeschlossen',
      successMessage2:
        'Verknüpfung der Seite, abgeschlossen. Die Modellsynchronisation wird gestartet',
      errorMessage:
        'Verknüpfung fehlgeschlagen, die Modellsynchronisation wird nicht gestartet',
      importUsers: 'Benutzer importieren',
      importUsersSubHeading:
        'Fügen Sie hinzu und verwalten Sie, was Sie importieren möchten, indem Sie die CSV-Vorlage herunterladen.',
      dropCsvHere: 'Datei hierher ziehen und ablegen oder',
      browsrForFiles: 'Dateien durchsuchen',
      subHeadingBrowser:
        'Nur CSV-Dateien werden akzeptiert und die Datei darf 5 MB nicht überschreiten.',
      subHeadingBrowserTwo: '(nur ein Upload gleichzeitig möglich)',
      userUploadSuccess: 'Successfully data sent',
      userUploadProcessing:
        'The data has been successfully uploaded. We are currently processing and will take a few minutes. We will update you soon.',
      fileNameDisplay: 'File Name :',
      fileName: 'File Name',
      errorNotification:
        'We encountered an issue while uploading the template, please rectify below errors and re-upload the template.',
      errorHeading: 'Fehler',
      slnumber: 'SL NO.',
      errorMessageHeading: 'ERROR MESSAGE',
      endUserAgreement: 'Honeywell Forge-Nutzungsbedingungen',
      privacyStatement: 'Datenschutzerklärung',
      yourPrivacyChoices: 'Ihre Datenschutzoptionen',
      cookieNotice: 'Cookie-Hinweis',
      dataCentre: 'Rechenzentrum',
      isForgeText: 'Gebäude',
      gatewayIdleMessage:
        'Sie waren einige Minuten inaktiv. Bitte aktualisieren Sie die Seite, um fortzufahren.',
      refresh: 'Aktualisieren',
      landingLogin: 'Hier klicken',
      loginUserIntegratorRole: 'BA e-commerce Benutzer',
      loginUserCustomerRole: 'Alle anderen Benutzer',
      loginWelcomeNote:
        'Willkommen, Bitte wählen Sie unten Ihre Rolle aus, um zu beginnen.',
      termsAndConditions: 'Geschäftsbedingungen',
      accept: 'Akzeptieren',
      legalPatentInformation: 'Rechtliche Patentinformationen',
      onboardingPortal: 'Onboarding Portal',
      customers: 'Kunden',
      templates: 'Vorlagen',
      assetModelling: 'Ressourcenmodellierung',
      selectCustomer: 'Kunden auswählen',
      integration: 'Integration',
      integrationSubtitle:
        'Für Echtzeit-Leistungserkenntnisse nahtlos integrieren',
      customer: 'Kunde',
      accessibleCustomersError: 'Fehler beim Abrufen zugänglicher Kunden',
      workflows: 'Workflows (veraltet)',
      apiCredentials: 'API-Anmeldeinformationen',
      integrationsTab: 'Workflows',
      noSubscription:
        'Kein aktives Abonnement gefunden. Bitte schließen Sie ein Abonnement ab, um auf diese Funktion zuzugreifen.',
      loading: 'Laden...',
      licenseManagement: 'Lizenzverwaltung',
      activityLogTitle: 'Aktivitätsprotokolle',
      activityLogSubtitle:
        'Workflow-Ereignisse und Statusaktualisierungen für ausgewählte Kunden verfolgen',
      activityLogSidebarTitle: 'Aktivitätsprotokolle',
      activityLogSidebarSubtitle:
        'Hier sind die Aktivitätsdaten für alle Ihre Kundenorganisationen.',
      activityLogListTitle: 'Aktivitätenliste',
      activityLogSearchPlaceholder: 'Nach Aktivität, Website suchen',
      activityLogLastUpdated: 'Letzte Aktualisierung',
      activityLogCreatedOn: 'Erstellt am',
      activityLogActivity: 'Aktivität',
      activityLogSite: 'Standort',
      activityLogStatus: 'Status',
      activityLogCreatedBy: 'Erstellt von',
      activityLogUpdatedBy: 'Aktualisiert von',
      activityLogNameUnavailable: 'Name nicht verfügbar',
      activityLogUserNamesError:
        'Namen von CreatedBy/UpdatedBy konnten nicht geladen werden',
      activityLogStatusSuccess: 'Erfolg',
      activityLogStatusFailed: 'Fehler',
      activityLogStatusInProgress: 'In Bearbeitung',
      activityLogStatusQueued: 'In Warteschlange',
      activityLogStatusPending: 'Anhängig',
      activityLogStatusSkipped: 'Übersprungen',
      activityLogPaginationInfo:
        '{startItem} bis {endItem} von {totalItems} Elementen',
      activityLogPageGoTo: 'Zur Seite',
      activityLogRowPerPage: 'Zeilen pro Seite',
      activityLogRetry: 'Wiederholen',
      activityLogRetrying: 'Wird erneut versucht ...',
      activityLogRetrySuccess:
        'Die erneute Ausführung der Aufgabe wurde erfolgreich initiiert.',
      activityLogRetryError:
        'Aufgabe konnte nicht wiederholt werden. Bitte versuchen Sie es erneut.',
      activityLogRetryAllSuccess:
        'Die erneute Ausführung aller Aufgaben war erfolgreich.',
      activityLogRetryAllFailed:
        'Alle Wiederholungsversuche sind fehlgeschlagen. Bitte versuchen Sie es erneut.',
      activityLogRetryPartialFailed:
        'Einige Aufgaben konnten nicht wiederholt werden. Bitte versuchen Sie es erneut.',
      activityLogLoading: 'Details werden geladen...',
      activityLogFetchError:
        'Aktivitätsdaten konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
      activityLogModalClose: 'Schließen',
      activityLogModalTasks: 'Aufgaben',
      activityLogModalCreatedOn: 'Erstellt am',
      activityLogModalLastUpdatedOn: 'Letzte Aktualisierung am',
      activityLogModalSupportNote:
        'Beschreibung des Ausfallereignisses und des Ursachencodes.',
      activityLogModalSupportReach: 'Für Unterstützung wenden Sie sich an',
      activityLogModalSupportEmail: 'connectedbuildingsupport@honeywell.com',
      activityLogFilterTitle: 'Filtern nach',
      noCustomersAvailable: 'Keine Kunden verfügbar',
      activityLogFilterStatus: 'Status',
      activityLogFilterActivity: 'Aktivität',
      activityLogFilterSite: 'Standort',
      activityLogFilterCreatedBy: 'Erstellt von',
      activityLogFilterApply: 'Anwenden',
      activityLogFilterReset: 'Zurücksetzen',
      activityLogFilterNoOptions: 'Keine Optionen verfügbar',
      activityLogFilterError:
        'Fehler beim Laden der Filteroptionen. Bitte versuchen Sie es erneut.',
      search: 'Suchen',
      more: 'mehr',
      noResults: 'Keine Ergebnisse gefunden',
      activityLogCustomizeColumns: 'Spalten anpassen',
      activityLogColumnsReorder: 'Neu anordnen',
      activityLogColumnsAddRemove: 'Hinzufügen/Entfernen',
      activityLogColumnsReorderDescription:
        'Neu positionieren, um die Reihenfolge der Spalten in der Tabelle zu ändern',
      activityLogColumnsAddRemoveDescription:
        'Spalten markieren, um sie in der Tabelle anzuzeigen',
      activityLogDetails: 'Details',
      activityLogFiltersChanged:
        'Für die ausgewählten Filter wurden keine Daten gefunden. Bitte passen Sie Ihre Filter an oder setzen Sie Ihre Filter zurück, um Ergebnisse anzuzeigen.',
      activityLogResetFilters: 'Filter zurücksetzen',
      activityLogSiteState: 'Zustand',
      activityLogSiteCity: 'Stadt',
      workflowTaskCBCustomerCreation: 'CB-Kundenerstellung',
      workflowTaskOnboardingStatusUpdatePartnerPortal:
        'Aktualisierung des Onboarding-Status im Partnerportal',
      workflowTaskUpdateCBCustomerIdPartnerPortal:
        'CB-Kunden-ID im Partnerportal aktualisieren',
      workflowTaskEOMCustomerCreation: 'EOM-Kundenerstellung',
      workflowTaskOnboardCustomerForAI: 'Kunde für KI integrieren',
      workflowTaskDeleteCustomerInCBPortal: 'Kunde im CB-Portal löschen',
      workflowTaskUpdateCustomerInCBPortal: 'Kunde im CB-Portal aktualisieren',
      workflowTaskUpdateCustomerInEOM: 'Kunde in EOM aktualisieren',
      workflowTaskUpdateCustomerInAssetModelling:
        'Kunden in der Asset-Modellierung aktualisieren',
      workflowTaskTrackScanStatusFileAttachment:
        'Scan-Status des Dateianhangs nachverfolgen',
      workflowTaskCBSiteCreation: 'CB-Standorterstellung',
      workflowTaskUpdateCBSiteIdPartnerPortal:
        'CB-Standort-ID im Partnerportal aktualisieren',
      workflowTaskEOMSiteCreation: 'Erstellung des EOM-Standorts',
      workflowTaskUpdateEOMSiteIdPartnerPortal:
        'EOM-Standort-ID im Partnerportal aktualisieren',
      workflowTaskSyncExistingUsersCBPortal:
        'Vorhandene Benutzer mit CB-Portal synchronisieren',
      workflowTaskUpdateUserSyncStatusPartnerPortal:
        'Synchronisierungsstatus des Benutzers im Partnerportal aktualisieren',
      workflowTaskCalculateEnergySavingsPotential:
        'Energieeinsparpotenzial berechnen',
      workflowTaskDeleteSiteInCBPortal: 'Standort im CB-Portal löschen',
      workflowTaskDeleteSiteInEOM: 'Standort in EOM löschen',
      workflowTaskUpdateSiteInCBPortal: 'Standort im CB-Portal aktualisieren',
      workflowTaskUpdateSiteInEOM: 'Standort in EOM aktualisieren',
      workflowTaskUpdateSiteInAssetModelling:
        'Standort in der Anlagenmodellierung aktualisieren',
      workflowTaskUpdateSiteInFindAPI: 'Standort in Find-API suchen',
      workflowTaskSyncSubscriptionAssociationCBPortal:
        'Abonnementzuordnung zum CB-Portal synchronisieren',
      workflowTaskEnableBrickOntology: 'Brick-Ontologie aktivieren',
      workflowTaskOnboardCustomerForgeAPI: 'Kunde in ForgeAPI integrieren',
      workflowTaskPublishForgeAPIOnboardingStatus:
        'ForgeAPI-Onboarding-Status in der Verwaltung für Anmeldeinformationen veröffentlichen',
      workflowTaskAddUserInCBPortal: 'Benutzer im CB-Portal hinzufügen',
      workflowTaskUpdateUserProvisioningStatus:
        'Bereitstellungsstatus des Benutzers aktualisieren',
      workflowTaskDeleteUserInCBPortal: 'Benutzer im CB-Portal löschen',
      workflowTaskUpdateUserDeletionStatus:
        'Status der Benutzerlöschung aktualisieren',
      workflowCustomerCreation: 'Kundenerstellung',
      workflowCustomerDelete: 'Kundenlöschung',
      workflowCustomerUpdate: 'Kundenaktualisierung',
      workflowFileAttachmentsScan: 'Scan-Status der Dateianhänge',
      workflowSiteCreation: 'Standorterstellung',
      workflowSiteDelete: 'Standortlöschung',
      workflowSiteUpdate: 'Standortaktualisierung',
      workflowSubscriptionAssociation: 'Abonnementzuordnung',
      workflowAddUser: 'Benutzer hinzufügen',
      workflowDeleteUser: 'Benutzer löschen',
      workflowNamePlate: 'Typenschild',
      workflowForgeAPIOnboarding: 'Forge-API-Onboarding',
      workflowAddUserMultiple: 'Workflow zum Hinzufügen mehrerer Benutzer',
      workflowDeleteUserMultiple: 'Workflow zum Löschen mehrerer Benutzer',
      workflowModelFileUpload: 'Modelldatei-Upload',
      workflowGatewayAssociation: 'Gateway-Zuordnung',
      workflowIntegrationRegistered: 'Integration registriert',
      workflowTaskForgeAPIOnboardingStatus: 'Status des Forge-API-Onboardings',
      workflowTaskAddUser: 'Workflow zum Hinzufügen eines Benutzers',
      workflowTaskProcessModelFile: 'Modelldatei verarbeiten',
      workflowTaskNotifyAssetModelling: 'Asset-Modellierung benachrichtigen',
      workflowTaskAssociateGateway: 'Gateway mit Standort verknüpfen',
      workflowTaskFetchModelToAssetModelling:
        'Modell für die Asset-Modellierung abrufen',
      workflowTaskNameProcessNamePlate: 'Verarbeitung der Typenschilddatei',
      workflowTaskUpdateModelInFindAPI: 'Modell in Find-API aktualisieren',
      workflowTaskProcessIntegrationRegistered:
        'Prozessintegration registriert',
      workflowTaskProcessDFNotificationIntegrationRegistered:
        'DF-Benachrichtigung zur registrierten Integration verarbeiten',
      workflowTaskTenantOnboardingAFO: 'Mandanten-Onboarding in AFO',
      workflowTaskOnboardCustomerCDL: 'Kunde für CDL integrieren',
      workflowTaskPublishAFOOnboardingStatus: 'AFO-Onboarding-Status an den Rule Builder-Dienst veröffentlichen',
      activityLogCorrelationId: 'Korrelations-ID',
      activityLogTaskId: 'Aufgaben-ID',
      activityLogToastSuccess: 'Erfolg',
      activityLogToastError: 'Fehler',
      activityLogIteration: 'Wiederholung',
      activityLogFieldFirstName: 'Vorname',
      activityLogFieldLastName: 'Nachname',
      activityLogFieldSubscriptionName: 'Abonnementname',
      activityLogFieldName: 'Name',
      activityLogFieldCurrency: 'Währung',
      activityLogFieldZip: 'PLZ',
      activityLogFieldArea: 'Bereich',
      activityLogFieldCity: 'Stadt',
      activityLogFieldState: 'Zustand',
      activityLogFieldCountry: 'Land',
      activityLogFieldAreaUnit: 'Bereichseinheit',
      activityLogFieldLanguage: 'Sprache',
      activityLogFieldLatitude: 'Breitengrad',
      activityLogFieldSiteType: 'Standort-Typ',
      activityLogFieldTimezone: 'Zeitzone',
      activityLogFieldLongitude: 'Längengrad',
      activityLogFieldCountryCode: 'Ländervorwahl',
      activityLogFieldSiteId: 'Site-ID',
      activityLogFieldFileType: 'Dateityp',
      activityLogFieldReason: 'Grund',
      activityLogFieldCustomerSupportEmails: 'E-Mail-Adressen des Kundensupports',
      activityLogFieldAddressLine1: 'Adresszeile 1',
      activityLogFieldAddressLine2: 'Adresszeile 2',
      activityLogFieldContactEmail: 'Kontakt-E-Mail-Adresse',
      activityLogSiTitle: 'Aktivitätsprotokoll',
      support: 'Support',
      projectManagement: 'Projektmanagement',
    }
  }
};
